import styled from 'styled-components';

export const StyledListItem = styled.li`
  display: flex;
  padding: 16px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--bg-500, #373245);
  background: var(--bg-600, #2e2a3a);
`;
